/**
 * Created by PetitKero on 30/9/2016.
 */
/*eslint-disable*/

import store from '../index'
import config from '../../nim/configs';
import { data } from 'autoprefixer';

const _ = window._
const mutations = {
    // 更改整体的大小
    update_containerSize(state, data) {
        state.containerSize = data;
    },
    // 更改登录加载中状态
    update_loading(state, data) {
        state.loading = data;
        // 更改登录状态
        state.isLoading = true;
    },
    // 更改登录状态
    update_isLoading(state, data) {
        state.isLoading = data;
    },
    //通讯录选中的公司
    update_selectItem(state, data) {
        state.selectItem = data;
    },
    //通讯录选中的公司下部门
    update_depItem(state, data) {
        state.depItem = data;
    },
    // 更新当前聊天的消息列表
    update_currentMessageList(state, data) {
        state.currSessionMsgs = state.msgs[data.id] || [];
    },
    // 更新当前聊天对象信息
    update_currentObjInfo(state, data) {
        state.currentChatType = data.scene;
        state.currSessionId = data.id;
        state.currSessionTo = data.to;
    },
    // 存储当前登录的用户id
    update_userUID(state, data) {
        state.userUID = data;
    },
    // 存储当前登录的用户信息
    update_currentLoginUser(state, data) {
        state.myInfo = data;
    },
    // 收到消息添加到本地列表
    update_msgs(state, date) {
        state.msgs = date;
    },
    // 更改当前聊天的用户信息
    update_currChatUserInfo(state, data) {
        state.currChatUserInfo = data;
    },
    // 更改当前聊天的群组信息
    update_currChatGroupInfo(state, data) {
        state.currChatGroupInfo = data;
    },
    // 更新群聊列表
    update_groupList(state, data) {
        state.groupList = window.nim.mergeTeams(state.groupList, data.team);
    },
    // 更新会话列表
    update_sessionList(state, data) {
        state.sessionlist = window.nim.mergeSessions(state.sessionlist, data);
    },
    // 更改选中人员
    update_selectpersonnelList(state, data) {
        state.selectpersonnelList = data;
    },
    update_selectpersonneIsno(state, data) {
        state.selectpersonneIsno = data;
    },
    // 设置群组列表
    SET_TEAMS(state, teams) {
        if (!Array.isArray(teams)) {
            teams = [teams]
        }
        teams = teams.filter(item => !!item)
        teams.forEach(team => {
            if (team.validToCurrentUser === undefined) {
                team.validToCurrentUser = true
            }
        })
        let list = window.nim.mergeTeams(state.teams, teams)
        list = window.nim.cutTeams(list, teams.invalid)
        state.teams = list
    },
    SET_TEAMMENBER(state, obj) {
        let json = Object.assign({}, state.teamMember)
        json[obj.teamId] = obj.menber
        state.teamMember = json
    },
    // 更改home左侧active索引
    update_homeActiveIndexTag(state, data) {
        state.homeActiveIndexTag = data;
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations/index.js